import React, { lazy, Suspense, useState, useEffect } from 'react';
import { Route } from 'react-router-dom';
import { isMobile } from '../utils/device';

// import DesktopRoutes from '../platform/desktop/routes';

const DesktopRoutes = lazy(() => import('../platform/desktop'));
const MobileRoutes = lazy(() => import('../platform/mobile'));

export default ({ path, component, mobile, service }) => {
  const [state, setState] = useState(component);

  useEffect(() => {
    setState(component);
    if (service) {
      setTimeout(() => {
        setState('Restaurant');
      }, 500);
    }
  }, [path]);

  return (
    <>
      {state ? (
        <Route path={path}>
          <Suspense fallback={<div>Loading</div>}>
            {isMobile() && mobile ? (
              <MobileRoutes component={state} />
            ) : (
              <DesktopRoutes component={state} />
            )}
          </Suspense>
        </Route>
      ) : (
        <div>Loading</div>
      )}
    </>
  );
};
